/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttributeGroupsAg } from '../../models/attribute-groups-ag';

export interface GetAttributeGroupsById$Params {
  orid: number;
  agid: number;
}

export function getAttributeGroupsById(http: HttpClient, rootUrl: string, params: GetAttributeGroupsById$Params, context?: HttpContext): Observable<StrictHttpResponse<AttributeGroupsAg>> {
  const rb = new RequestBuilder(rootUrl, getAttributeGroupsById.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
    rb.path('agid', params.agid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AttributeGroupsAg>;
    })
  );
}

getAttributeGroupsById.PATH = '/api/AttributeGroups/attributeGroupsById/{orid}/{agid}';
